import React, { useEffect, useState } from "react";

import { SELECT } from "../../../../constants/Constants";

const ConfigOptions = ({ labelName, configValues }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const configVal = configValues.filter((config) => config.key === labelName);
    const selectOptions = JSON.parse(
      configVal?.length > 0 && configVal[0].value
    );

    setOptions(selectOptions);
  }, []);

  return (
    <>
      <option value="" selected disabled>
        {SELECT}
      </option>
      {options.map((option, index) => {
        let element = {};
        element = (
          <option key={index} value={option.name}>
            {option.value}
          </option>
        );
        return element;
      })}
    </>
  );
};

export default ConfigOptions;
